var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      staticClass: "mainWrapper",
      attrs: { lg: 3, md: 4, sm: 6, xl: 1, xs: 8 }
    },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("header-nav", { on: { spread: _vm.spread } }),
          _vm._v(" "),
          _c(
            "el-main",
            { staticStyle: { padding: "0", overflow: "visible" } },
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    active: _vm.activeStep - 1,
                    "align-center": "",
                    "finish-status": "success"
                  }
                },
                [
                  _c("el-step", {
                    attrs: { title: "Step 1", description: "Plan" }
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: { title: "Step 2", description: "User Details" }
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: { title: "Step 3", description: "payment" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("router-view", { on: { stepChanged: _vm.stepChanged } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0" } },
            [_c("foot-nav", { attrs: { showQus: _vm.showFootTxt } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f316942", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f316942","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/uConnectSubscriptionStepsLayout.vue
// module id = null
// module chunks = 